<template>
    <v-app-bar color="#222" dark height="55">
        <!-- Desktop Content -->
        <template v-if="$vuetify.breakpoint.mdAndUp">
            <img src="../../assets/img/logo.png" alt="Logo" class="logo" />
            <div class="separador"></div>
            <div class="text">Aplicación</div>
            <div class="separadorTexto">></div>
            <div class="text">Lem App</div>
            
            <v-spacer></v-spacer>
            <MapNavigation v-if="isHomeRoute" />
        </template>

        <!-- Mobile Menu -->
        <template v-else>
            <!-- <RouteNavigation /> -->
            <MapNavigation v-if="isHomeRoute" />

            <v-spacer></v-spacer>

            <img src="../../assets/img/logo.png" alt="Logo" class="logo" />
        </template>
    </v-app-bar>
</template>

<script>
import RouteNavigation from './HeaderNavigation/RouteNavigation.vue';
import MapNavigation from './HeaderNavigation/MapNavigation.vue';

export default {
    components: {
        RouteNavigation,
        MapNavigation
    },
    computed: {
        isHomeRoute() {
            return this.$route.name === 'Home';
        }
    },
};
</script>

<style scoped>
.logo {
    width: 9rem;
    height: 1.3rem;
}

.separador {
    width: 2px;
    height: 1.3rem;
    background: rgb(19, 75, 69);
    margin: 0 15px;
}

.separadorTexto {
    color: white;
    font-size: 0.78rem;
    font-weight: bolder;
    margin: 0px 10px;
}

.text {
    color: white;
    font-size: 0.78rem;
}
</style>